import tool from 'Src/util/tool'
import Pages from 'Src/const/pages'

const whiteList = ['en', 'ja']
let locale
try {
  locale = $.cookie('locale') || tool.queryToJson().locale || ''
} catch (e) {}

// window.bp_translation_zh_to_ja 记录中文和日文的映射关系, 主要目的在于防止日文被sdk二次翻译
window.bp_translation_zh_to_ja = {}

export const i18n = new VueI18n({
  locale: locale, // 设置地区
  messages: window.bp_platform_web_langs || {} // 设置地区信息, cdn获取
})

const newInstance = new Vue({
  i18n
})

// 全局挂载$bp_t方法 便于Js文件使用
window.$bp_t = (source, key, ...args) => {
  const value = Vue.prototype.$t.apply(newInstance, [key, ...args])
  window.bp_translation_zh_to_ja[key] = value
  return value === key ? source : value
}

// 组件内部全局注册$bp_t方法
Vue.mixin({
  methods: {
    $bp_t (...args) {
      return window.$bp_t.apply(this, args)
    }
  }
})

// 处理样式属性lang
if (document.documentElement) {
  document.documentElement.lang = whiteList.includes(locale) ? locale : 'zh'
}

// 处理标题 巨量引擎广告投放平台
if (document.title === Pages.index.title) {
  document.title = window.$bp_t(Pages.index.title, 'common.const_pages_platform_name')
}

// 处理BUI内置语言包
try {
  if (whiteList.includes(locale)) {
    const { Locale, lang } = BUI
    Vue.use(Locale)
    Locale.use(locale, lang[locale])
  }
} catch (e) {
  console.log('bui locale init error')
}
